<template >
[ReservationInput]

  <!-- -->
  <template
    v-if="loading.data === null"
  >


    <div
      class="list-group"
    >
      <div
          class="list-group-item"
      >
        Name: <pre>{{inputModel.contacts}}</pre>

      </div>

      <div
        class="list-group-item"
      >
        Spot: {{inputModel.spot_title}}
      </div>
      <div
          class="list-group-item"
      >
        Status: {{inputModel.status_title}}
      </div>

      <div
          class="list-group-item"
      >
        Note: {{inputModel.note}}
      </div>
      <div
          class="list-group-item text-end"
      >
        <a
            @click.prevent="openWindow()"
            href="#detail"
            class="btn btn-outline-primary btn-sm"
        >
          detail rezervace
        </a>
      </div>
    </div>



<!---->
    <display-debug>
      <template #debugView>inputModel {{inputModel}}</template>
    </display-debug>

  </template>
  <template v-else>
    [loading]
  </template>

  <!-- modal start-->
  <display-debug>
    <template #debugView>RESERV modalOpen.router  {{modalOpen.router}}</template>
  </display-debug>


  <div
      v-if="
        modalOpenX
        && modalOpen.config
        && modalOpen.config.display

      "
  >

    <modal-window
        :title="modalOpen.title"
        :config="modalOpen.config"
    >
      <template #modal-content-slot>
        <component
            v-bind:is="'ContentIncludeView'"
            :router="modalOpen.router"
            :return-data="modalOpen.data"
            :form-prefill="modalOpen.prefill"
            :config="modalOpen.config"
        ></component>
      </template>
    </modal-window>
  </div>



  <!-- modal end-->

<!--
     <display-debug>
      <template #debugView>inputObj {{inputObj}}</template>
    </display-debug>
-->
</template>

<script>

import axios from "axios";
import ContentIncludeView from "@/views/ContentIncludeView";
import ModalWindow from '@/components/content/ModalWindow'
export default {
  name: "ReservationInput",
  components: {
    ContentIncludeView,
    ModalWindow,
  },
  props: {
    "inputObj": Object,
    "formObj": Object,
    "modelValue": {
      type: [Object],
      required: false,
      default: null,
    },
    "activeLang": {
      type: [String],
      required: false,
      default: null,
    },
  },
  data() {
    return {
      loading: {
        data: null,
      },
      inputModel: {},
      /* */
      modals: {
        'reservation_view': {
          title: this.$t('reservation.section.form.modal.title'),
          router: {
            //modul: this.getApiConfig('reservation.module'),
            //action_template: 'detail',
            //: 'detail'

            modul: this.inputObj.templates.router.module,
            action_template: this.inputObj.templates.router.action,
            action: this.inputObj.templates.router.action


          },
          config: {
            "display": true,
            "is_header": true,
            "is_close_btn": true,
            "is_footer": true
          },
          data: {
            save: false,
            submit: false,
          },
          prefill: {
            general: {
              inputs: {
                id: {
                  readonly: true,
                  //value: this.inputObj.val
                  value: null
                },
              }
            },
          },
        },
      },


      modalOpen: {},
    }
  },
  created() {
    this.inputModel = {};
    /*
    if(
        this.inputObj.templates.currency
    ) {
      for(const key in this.inputObj.templates.currency) {
        const types = {}
        for(const t in this.inputObj.templates.type) {
          types[t] = {
            condition: this.inputObj.templates.type[t].condition,
            isDisplay: true,
            value: null

          }; //null
        }
        this.inputModel[this.inputObj.templates.currency[key].ident] = types;
      }
    }
  */
  },
  mounted() {
    if(
        this.inputObj.val
    ) {
        this.loadReservation(this.inputObj.val)
   }
  },
  methods: {

    loadReservation(id) {
      const apiPath = this.inputObj.templates.detail_path + id; //+'/'

      //console.log("dev reservation loadReservation", id, apiPath);
      axios.defaults.baseURL = this.getBaseRoot();

      this.loading.data = true;
      //console.log('dev.InfiniteScrollList actionRowClick call rowClick getBaseRoot', this.getBaseRoot());
      axios({
        url: apiPath,
        //data: formData,
        method: 'get',
        withCredentials: true,
        headers: this.getRequestHeader(),
      }).then((res) => {
        //console.log('dev reservation loadReservation data', res.data.response.detail);
        if(res.data.response.detail) {
          this.inputModel = res.data.response.detail;
        }

      }).catch((err)=> {
        console.log('data err', err)
      }).finally(()=> {
        this.loading.data = null;

      })
      /**/


    },

    openWindow() {
      this.modals.reservation_view.data.submit = false;
      this.modals.reservation_view.data.saved = false;

      this.modals.reservation_view.prefill.general.inputs.id.value = this.inputObj.val;
      this.modals.reservation_view.config.display = true;
      //this.modalOpen = 'reservation_view';
      this.modalOpen = this.modals.reservation_view;
      //this.modalOpen.router.action = this.modals.reservation_view.router.action + '/' + this.inputObj.val
      this.modalOpen.router.action = this.getRouterAction(this.modals.reservation_view.router.action_template, this.inputObj.val)
      console.log('dev reservation openWindow', this.modalOpen, this.inputModel);
    },


    getRouterAction(prefix, id) {
        return prefix + '/' + id + '?lang_code=' + this.$i18n.locale;
    },


    closeWindow() {

    },


    getDisplayStatus(item, condition) {
      let status = true
      if(typeof condition != "undefined" && condition) {
        for(const index_c in condition) {
          if(
              item[condition[index_c]].value == null
              || item[condition[index_c]].value <= 0
          ) {
            status = false;
          }
        }
      }
      return status
    }
  },
  watch: {
    inputModel: {
      handler(newVal) {
        this.$emit('update:modelValue', newVal )
      },
      deep: true,
      immediate: true
    },
    "modals.reservation_view.data.data": {
      handler(newVal) {
        if(newVal){
          console.log('dev.menu modals modals.reservation_view.data', newVal)


          this.modals.reservation_view.data.submit = true;
          this.modals.reservation_view.data.saved = true;
          this.modals.reservation_view.config.display = false;
        }

        //console.log('dev.menu modals modals.section_create.data', newVal)
      },
      deep: true,
      immediate: true
    },
  },
};
</script>